import { IconsBarArea, LabelIcon } from "./styles";
import React, { useContext } from "react";
import { ReactComponent as RegistrationIcon } from "../../assets/register_icon.svg";
import { ReactComponent as DocumentsIcon } from "../../assets/documents.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";
import { ReactComponent as AnnouncementsIcon } from "../../assets/announcements.svg";
import { ReactComponent as NotificationsIcon } from "../../assets/notifications.svg";
import { ReactComponent as BookIcon } from "../../assets/book-open.svg";
import { ReactComponent as GradesIcon } from "../../assets/grades.svg";
import { ReactComponent as IntegranteIcon } from "../../assets/integrante_icon.svg";
import { ReactComponent as StatsIcon } from "../../assets/stats.svg";
import { ReactComponent as SettingsIcon } from "../../assets/config.svg";
import { ReactComponent as FileViewIcon } from "../../assets/file-view.svg";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { staffCanAccessMenu } from "../../config/menuAccessCatalog";

const StoreIcon = ({ width = 25, height = 25 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 52.5H52.5V47.5L50 30H10L7.5 47.5V52.5ZM12.5 25H47.5L51.25 10H8.75L12.5 25ZM17.5 35V45H22.5V35H17.5ZM27.5 35V45H32.5V35H27.5ZM37.5 35V45H42.5V35H37.5Z"
      fill="currentColor"
    />
  </svg>
);

const HrIcon = ({ width = 25, height = 25 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      fill="currentColor"
    />
  </svg>
);

const LeadsIcon = ({ width = 25, height = 25 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
      fill="currentColor"
    />
  </svg>
);

const EventsIcon = ({ width = 25, height = 25 }) => <CalendarIcon width={width} height={height} />;

const IconsBar = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  if (!user || !user.level) {
    return <IconsBarArea />;
  }

  const can = (menuId) => staffCanAccessMenu(user, menuId);

  return (
    <IconsBarArea>
      {can("diary") && (
        <Link
          to={"/autentico/diary"}
          className={isActive("/autentico/diary") ? "active" : ""}
        >
          <CalendarIcon width={25} height={25} />
          <LabelIcon>Agendas</LabelIcon>
        </Link>
      )}

      {can("grades") && (
        <Link
          to={"/autentico/grades"}
          className={isActive("/autentico/grades") ? "active" : ""}
        >
          <GradesIcon width={35} height={25} />
          <LabelIcon>Avaliações</LabelIcon>
        </Link>
      )}

      {can("canteen") && (
        <Link
          to={"/autentico/canteen"}
          className={isActive("/autentico/canteen") ? "active" : ""}
        >
          <StoreIcon width={25} height={25} />
          <LabelIcon>Cantina</LabelIcon>
        </Link>
      )}

      {can("events_admin") && can("events_view") && (
        <Link to="/autentico/events" className={isActive("/autentico/events") ? "active" : ""}>
          <EventsIcon width={25} height={25} />
          <LabelIcon>Eventos</LabelIcon>
        </Link>
      )}

      {can("announcements") && (
        <Link
          to={"/autentico/announcements"}
          className={isActive("/autentico/announcements") ? "active" : ""}
        >
          <AnnouncementsIcon width={25} height={25} />
          <LabelIcon>Comunicados</LabelIcon>
        </Link>
      )}

      {can("secretary") && (
        <Link
          to={"/autentico/secretary"}
          className={isActive("/autentico/secretary") ? "active" : ""}
        >
          <DocumentsIcon width={25} height={25} />
          <LabelIcon>Documentos</LabelIcon>
        </Link>
      )}

      {can("stats") && (
        <Link
          to={"/autentico/stats"}
          className={isActive("/autentico/stats") ? "active" : ""}
        >
          <StatsIcon width={25} height={25} />
          <LabelIcon>Estatísticas</LabelIcon>
        </Link>
      )}

      {can("questionnaires_admin") && (
        <Link
          to={"/autentico/questionnaires"}
          className={isActive("/autentico/questionnaires") ? "active" : ""}
        >
          <BookIcon width={25} height={25} />
          <LabelIcon>Questionários</LabelIcon>
        </Link>
      )}

      {can("integrante") && (
        <Link
          to={"/autentico/integrante"}
          className={isActive("/autentico/integrante") ? "active" : ""}
        >
          <IntegranteIcon width={25} height={25} />
          <LabelIcon>Integral</LabelIcon>
        </Link>
      )}

      {can("grade_logs") && (
        <Link
          to={"/autentico/grades/logs"}
          className={isActive("/autentico/grades/logs") ? "active" : ""}
        >
          <FileViewIcon width={25} height={25} />
          <LabelIcon>Log Notas</LabelIcon>
        </Link>
      )}

      {can("registration") && (
        <Link
          to={"/autentico/registration"}
          className={isActive("/autentico/registration") ? "active" : ""}
        >
          <RegistrationIcon width={25} height={25} />
          <LabelIcon>Matrículas</LabelIcon>
        </Link>
      )}

      {can("enrollment_crm") && (
        <Link
          to={"/autentico/crm-matriculas"}
          className={isActive("/autentico/crm-matriculas") ? "active" : ""}
        >
          <LeadsIcon width={25} height={25} />
          <LabelIcon>Leads</LabelIcon>
        </Link>
      )}

      {can("individual_messages") && (
        <Link
          to={"/autentico/individual-messages"}
          className={isActive("/autentico/individual-messages") ? "active" : ""}
        >
          <NotificationsIcon width={25} height={25} />
          <LabelIcon>Mensagens</LabelIcon>
        </Link>
      )}

      {can("planning") && (
        <Link
          to={"/autentico/planning"}
          className={isActive("/autentico/planning") ? "active" : ""}
        >
          <BookIcon width={25} height={25} />
          <LabelIcon>Planejamento</LabelIcon>
        </Link>
      )}

      {can("holerites") && (
        <Link
          to={"/autentico/rh/holerites"}
          className={isActive("/autentico/rh/holerites") ? "active" : ""}
        >
          <HrIcon width={25} height={25} />
          <LabelIcon>RH</LabelIcon>
        </Link>
      )}

      {can("config") && (
        <Link
          to={"/autentico/config"}
          className={isActive("/autentico/config") ? "active" : ""}
        >
          <SettingsIcon width={30} height={25} />
          <LabelIcon>Configurações</LabelIcon>
        </Link>
      )}
    </IconsBarArea>
  );
};

export default IconsBar;
